import { API_URL } from '../../../app-config/constants';
import { DownloadableFile } from '../../../types/DownloadableFile';
import { get, remove } from '../request';
const BASE_PATH = `${API_URL}/downloadable-file`;

export function getFile(id: string): Promise<DownloadableFile> {
    return get(`${BASE_PATH}/${id}`);
}

getAll.operation = 'READ';
export function getAll(query: any): Promise<DownloadableFile[]> {
    return get(BASE_PATH, { getData: query });
}

poll.invalidates = ['getAll'];
export function poll(query: any): Promise<DownloadableFile[]> {
    return get(BASE_PATH, { getData: query });
}

deleteDownload.operation = 'DELETE';
export function deleteDownload({ id }: { id: string }): Promise<never> {
    return remove(`${BASE_PATH}/${id}`);
}
